import React, { useContext } from "react";
import { Input } from "antd";
import Form from "antd/lib/form/Form";
import { ImplementerProfileFormContext } from "../../ImplementerProfileFormContext";
import { DirectorsBoardMember } from "../../../../../types";

interface DirectorNameInputProps {
  member: DirectorsBoardMember;
  onChange: ({ key, value }: { key: string; value: string }) => void;
}

export const DirectorChargeInput = (props: DirectorNameInputProps) => {
  const implementerAccountContext = useContext(ImplementerProfileFormContext);
  const { form, isBusy } = implementerAccountContext;
  const { getFieldDecorator } = form;
  const { member, onChange } = props;

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange({ value: event.target.value, key: "charge" });
  };

  return (
    <Form.Item label="Cargo">
      {getFieldDecorator(`directorCharge.${props.member.id}`, {
        rules: [
          {
            required: true,
            message: "Por favor, ingresa el cargo."
          }
        ],
        initialValue: member?.charge
      })(
        <Input
          disabled={isBusy}
          id={`charge-${member.id}`}
          name="charge"
          placeholder="Cargo"
          onChange={handleOnChange}
          size="large" />
      )}
    </Form.Item>
  );
};
